<div id="close" class="close-cross" (click)="closeModal()" #close>
  <img src="{{ assetsUrl }}/assets/images/x.png" srcset="{{ assetsUrl }}/assets/images/x@2x.png 2x,
                       {{ assetsUrl }}/assets/images/x@3x.png 3x" class="img-fluid">
</div>
